// Complete website data for LookWell Gents Salon

export const siteInfo = {
  name: "LookWell Gents Salon",
  tagline: "Your Ultimate Grooming Destination in the Heart of Dubai",
  phone: "+971 564 740 785",
  whatsapp: "+971564740785",
  email: "inquiry@lookwellgentssalon.com",
  address: {
    line1: "Blue Building, Al Nahda 2",
    line2: "Dubai, United Arab Emirates",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.5739246938735!2d55.377599!3d25.306167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDE4JzIyLjIiTiA1NcKwMjInMzkuNCJF!5e0!3m2!1sen!2sae!4v1234567890"
  },
  hours: "Open 7 Days: 6:00 AM - 2:00 AM",
  fridayBreak: "Friday Prayer Time: 1:00 PM - 2:00 PM",
  social: {
    facebook: "#",
    instagram: "#",
    twitter: "#"
  }
};

export const heroSection = {
  title: "Premium Grooming for the Modern Gentleman",
  subtitle: "Experience world-class grooming services tailored for Dubai's distinguished professionals",
  cta: "Book Your Appointment",
  image: "https://www.rapidhairsalon.ae/img/img.png"
};

export const aboutContent = {
  title: "About LookWell Gents Salon",
  subtitle: "Where Tradition Meets Modern Excellence",
  description: "Established in the heart of Dubai, LookWell Gents Salon has become the premier destination for discerning gentlemen who demand excellence in grooming. We combine traditional barbering techniques with contemporary styling to deliver an unparalleled experience.",
  mission: "Our mission is to provide Dubai's professionals and businessmen with world-class grooming services in a luxurious, relaxing environment. We understand that in the UAE's fast-paced business world, your appearance is your brand.",
  values: [
    {
      title: "Premium Experience",
      description: "Experience luxury grooming in Dubai's most sophisticated atmosphere. Every visit is crafted to exceed expectations with meticulous attention to detail."
    },
    {
      title: "Master Craftsmen",
      description: "Our internationally certified stylists bring decades of combined expertise, mastering both traditional techniques and contemporary trends."
    },
    {
      title: "Hygiene Excellence",
      description: "We maintain the highest standards of cleanliness and sanitation, using sterilized tools and premium products for your safety and comfort."
    },
    {
      title: "Client-Centric Approach",
      description: "Your satisfaction drives everything we do. We listen, understand, and deliver personalized grooming solutions that enhance your unique style."
    }
  ],
  stats: [
    { number: "7+", label: "Years of Excellence" },
    { number: "5000+", label: "Happy Clients" },
    { number: "50+", label: "Expert Groomers" },
    { number: "100%", label: "Customer Satisfaction" }
  ]
};

export const teamMembers = [
  {
    id: 1,
    name: "Adam Phillips",
    role: "Master Barber",
    bio: "With over 15 years of experience, Adam specializes in classic and contemporary cuts. Trained in London and New York, he brings international expertise to Dubai.",
    image: "https://www.rapidhairsalon.ae/img/team-1.jpg",
    specialties: ["Precision Cuts", "Classic Styles", "Beard Sculpting"]
  },
  {
    id: 2,
    name: "Dylan Adams",
    role: "Hair Expert",
    bio: "Dylan is renowned for his innovative styling techniques and deep understanding of hair types. His expertise ensures every client leaves looking their absolute best.",
    image: "https://www.rapidhairsalon.ae/img/team-2.jpg",
    specialties: ["Modern Styles", "Hair Treatments", "Color Correction"]
  },
  {
    id: 3,
    name: "Gloria Edwards",
    role: "Beard Expert",
    bio: "Gloria's mastery of beard grooming is unmatched. She understands the cultural significance of facial hair in the UAE and delivers impeccable results.",
    image: "https://www.rapidhairsalon.ae/img/team-3.jpg",
    specialties: ["Beard Design", "Hot Towel Shaves", "Facial Grooming"]
  },
  {
    id: 4,
    name: "Josh Dunn",
    role: "Color Expert",
    bio: "Josh brings artistic flair to hair coloring, specializing in natural coverage and contemporary color trends. His attention to detail is exceptional.",
    image: "https://www.rapidhairsalon.ae/img/team-4.jpg",
    specialties: ["Color Treatments", "Highlights", "Gray Coverage"]
  }
];

export const services = {
  hairCare: {
    title: "Hair Care",
    subtitle: "Professional cuts and treatments for every style",
    description: "From classic executive cuts to modern trending styles, our hair care services are designed for Dubai's dynamic lifestyle. We use premium products suited for the UAE climate.",
    icon: "✂️",
    image: "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=1200&q=85",
    overview: "At LookWell Gents Salon, we offer comprehensive hair-related services including trendy and classic haircuts, professional styling for events, and specialized hair treatments for all hair types. Whether you're looking for a sharp business cut or a complete hair transformation, our expert stylists are here to help.",
    keyServices: [
      {
        title: "Haircut",
        description: "A detailed trim or style to suit your personal look. Our stylists work with you to create a cut that complements your face shape and lifestyle."
      },
      {
        title: "Hair Coloring",
        description: "Full color, highlights, or balayage to refresh or completely change your style. We use premium, long-lasting products for natural-looking results."
      },
      {
        title: "Scalp Treatments",
        description: "Revitalizing treatments that hydrate and nourish your scalp. Perfect for combating Dubai's climate and maintaining healthy hair."
      }
    ],
    ctaText: "Book Hair Appointment",
    services: [
      { id: 1, name: "Adult Haircut", price: "5 AED", description: "Professional styling and precision cutting", image: "https://www.rapidhairsalon.ae/img/Adult-Haircut.png" },
      { id: 2, name: "Children Haircut", price: "5 AED", description: "Gentle, patient service for young gentlemen", image: "https://www.rapidhairsalon.ae/img/Children-Haircut.png" },
      { id: 3, name: "Head Shave Razor", price: "5 AED", description: "Smooth, professional razor shave", image: "https://www.rapidhairsalon.ae/img/Head-Shave-Razor.png" },
      { id: 4, name: "Blow Dry", price: "5 AED", description: "Professional styling and finishing", image: "https://www.rapidhairsalon.ae/img/Blow-Dry.png" },
      { id: 5, name: "Head Shampoo", price: "5 AED", description: "Deep cleansing with premium products", image: "https://www.rapidhairsalon.ae/img/Head-Shampoo.png" },
      { id: 6, name: "Hair Oil Bath", price: "10 AED", description: "Nourishing treatment for hair health", image: "https://www.rapidhairsalon.ae/img/Hair-Oil-Bath.png" },
      { id: 7, name: "Hair Color (Apple)", price: "15 AED", description: "Natural-looking color application", image: "https://www.rapidhairsalon.ae/img/Hair-Color-(Apple).png" },
      { id: 8, name: "Hair Color (Keune)", price: "15 AED", description: "Premium European color treatment", image: "https://www.rapidhairsalon.ae/img/Hair-Color-(Keune).png" },
      { id: 9, name: "Hair Straightening", price: "15 AED", description: "Smooth, manageable results", image: "https://www.rapidhairsalon.ae/img/Hair-Straightening.png" },
      { id: 10, name: "Henna Speedy", price: "20 AED", description: "Traditional natural coloring", image: "https://www.rapidhairsalon.ae/img/Henna-Speedy.png" },
      { id: 11, name: "Hair Oil Bath Steam", price: "20 AED", description: "Deep conditioning with steam therapy", image: "https://www.rapidhairsalon.ae/img/Hair-Oil-Bath-Steam.png" },
      { id: 12, name: "Hair Highlighting", price: "20 AED", description: "Dimensional color enhancement", image: "https://www.rapidhairsalon.ae/img/Hair-Highlighting.png" },
      { id: 13, name: "Hair Color (Bigen)", price: "25 AED", description: "Long-lasting premium color", image: "https://www.rapidhairsalon.ae/img/Hair-Color-(Bigen).png" },
      { id: 14, name: "Dandruff Treatment", price: "25 AED", description: "Specialized scalp care solution", image: "https://www.rapidhairsalon.ae/img/Dandruff-Treatment.png" },
      { id: 15, name: "Hair Stitching (Full)", price: "40 AED", description: "Complete hair restoration service", image: "https://www.rapidhairsalon.ae/img/Hair-Stitching-(Full).png" }
    ]
  },
  faceCare: {
    title: "Face Care",
    subtitle: "Refresh and rejuvenate your skin",
    description: "Combat Dubai's climate with our specialized facial treatments. From deep cleansing to anti-aging, we offer services designed for the modern gentleman's skincare needs.",
    icon: "💆",
    image: "https://customer-assets.emergentagent.com/job_cb5dd817-9027-4f22-8b94-571da1c276cc/artifacts/9w98tkus_face.jpg",
    overview: "Our facial treatments are designed to rejuvenate the skin and maintain a healthy glow. We offer deep cleansing facials, exfoliation, anti-aging treatments, and hydration facials tailored specifically for men's skin care needs in the UAE's climate.",
    keyServices: [
      {
        title: "Deep Cleansing Facial",
        description: "Removes impurities and promotes healthy skin. This treatment unclogs pores, removes dead skin cells, and leaves your face feeling refreshed and revitalized."
      },
      {
        title: "Anti-Aging Facial",
        description: "Targets fine lines and wrinkles to promote smoother, firmer skin. Our specialized treatment helps restore youthful appearance and skin elasticity."
      },
      {
        title: "Hydrating Facial",
        description: "Restores moisture and nourishes dry, dull skin. Perfect for combating the effects of Dubai's hot, dry climate on your skin."
      }
    ],
    ctaText: "Book Facial Treatment",
    services: [
      { id: 1, name: "Black Mask", price: "5 AED", description: "Deep pore cleansing treatment", image: "https://www.rapidhairsalon.ae/img/Black-Mask.png" },
      { id: 2, name: "Nose Strip", price: "5 AED", description: "Instant blackhead removal", image: "https://www.rapidhairsalon.ae/img/Nose-Strip.png" },
      { id: 3, name: "Wax (Partial)", price: "5 AED", description: "Targeted facial hair removal", image: "https://www.rapidhairsalon.ae/img/Wax-(Partial).png" },
      { id: 4, name: "Threading (Half)", price: "5 AED", description: "Precise eyebrow grooming", image: "https://www.rapidhairsalon.ae/img/Threading-(Half).png" },
      { id: 5, name: "Threading (Full)", price: "10 AED", description: "Complete facial threading", image: "https://www.rapidhairsalon.ae/img/Threading-(full).png" },
      { id: 6, name: "Wax (Full Face)", price: "10 AED", description: "Complete facial waxing", image: "https://www.rapidhairsalon.ae/img/Wax-(Full-Face).png" },
      { id: 7, name: "Face Massage", price: "10 AED", description: "Relaxing facial massage therapy", image: "https://www.rapidhairsalon.ae/img/Face-Massage.png" },
      { id: 8, name: "Bleaching (Face)", price: "15 AED", description: "Brightening facial treatment", image: "https://www.rapidhairsalon.ae/img/Bleaching-(Face).png" },
      { id: 9, name: "Skin Polish", price: "15 AED", description: "Exfoliation and glow treatment", image: "https://www.rapidhairsalon.ae/img/Skin-Polish.png" },
      { id: 10, name: "Bleach Face & Hand", price: "20 AED", description: "Complete brightening service", image: "https://www.rapidhairsalon.ae/img/Bleach-Face-&-Hand.png" },
      { id: 11, name: "Black Mask & Nose Strip", price: "30 AED", description: "Comprehensive pore treatment", image: "https://www.rapidhairsalon.ae/img/Black-Mask-&-Nose-Strip.png" },
      { id: 12, name: "Facial & Skin Polish", price: "45 AED", description: "Premium facial package", image: "https://www.rapidhairsalon.ae/img/Facial-&-Skin-Polish.png" }
    ]
  },
  beardCare: {
    title: "Beard Care",
    subtitle: "Master your facial hair with expert grooming",
    description: "In the UAE, a well-groomed beard is a statement of style. Our beard specialists understand the art of beard grooming, from traditional shaves to modern styling.",
    icon: "🧔",
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1200&q=85",
    overview: "Our beard grooming services include trimming, shaping, and conditioning treatments. These services help maintain a sharp, clean look or enhance the fullness and shape of your beard. Whether you prefer a classic or contemporary style, we've got you covered.",
    keyServices: [
      {
        title: "Beard Trim",
        description: "Shaping your beard to create a clean, polished look. Our expert barbers trim and define your beard to complement your facial features."
      },
      {
        title: "Beard Shaping",
        description: "Defining the natural lines of your beard to enhance facial features. We create sharp lines and contours that make your beard look professionally groomed."
      },
      {
        title: "Beard Oil Treatment",
        description: "Nourishing and conditioning your beard for a soft, healthy feel. Our premium oils prevent dryness, reduce itchiness, and add a natural shine."
      }
    ],
    ctaText: "Book Beard Grooming",
    services: [
      { id: 1, name: "Beard Shave", price: "5 AED", description: "Clean, professional shave", image: "https://www.rapidhairsalon.ae/img/Beard-Shave.png" },
      { id: 2, name: "Beard Trimming", price: "5 AED", description: "Precision beard shaping", image: "https://www.rapidhairsalon.ae/img/Beard-Trimming.png" },
      { id: 3, name: "Beard Color (Apple)", price: "5 AED", description: "Natural beard coloring", image: "https://www.rapidhairsalon.ae/img/Beard-Color-(Apple).png" },
      { id: 4, name: "Beard Straightening", price: "10 AED", description: "Smooth, manageable beard", image: "https://www.rapidhairsalon.ae/img/Beard-Straightening.png" },
      { id: 5, name: "Beard Color (Keune)", price: "10 AED", description: "Premium beard color treatment", image: "https://www.rapidhairsalon.ae/img/Beard-Color-(Keune).png" },
      { id: 6, name: "Henna Speedy", price: "10 AED", description: "Traditional beard coloring", image: "https://www.rapidhairsalon.ae/img/Henna-Speedy-2.png" },
      { id: 7, name: "Beard Color (Bigen)", price: "15 AED", description: "Long-lasting beard color", image: "https://www.rapidhairsalon.ae/img/Beard-Color-(Bigen).png" }
    ]
  },
  relaxation: {
    title: "Relaxation",
    subtitle: "Unwind and de-stress with therapeutic treatments",
    description: "For Dubai's busy professionals, relaxation is essential. Our therapeutic massage services provide the perfect escape from the daily grind.",
    icon: "🧘",
    image: "https://images.unsplash.com/photo-1542848285-4777eb2a621e?w=1200&q=85",
    overview: "Our relaxation services focus on stress relief and overall well-being. We offer head and back massages, aromatherapy, and stress-relieving spa treatments designed to help you unwind, reduce tension, and improve your overall sense of wellness.",
    keyServices: [
      {
        title: "Head Massage",
        description: "A soothing treatment to relieve tension and promote relaxation. Perfect for relieving stress and headaches after a long day at work."
      },
      {
        title: "Back Massage",
        description: "Targets the back muscles to reduce pain and increase mobility. Our therapeutic massage techniques help release knots and improve circulation."
      },
      {
        title: "Aromatherapy",
        description: "Use of essential oils to provide a calming effect on both body and mind. Experience deep relaxation through the power of natural aromatherapy."
      }
    ],
    ctaText: "Book Relaxation Session",
    services: [
      { id: 1, name: "Head Massage", price: "5 AED", description: "Soothing scalp massage therapy", image: "https://www.rapidhairsalon.ae/img/Head-Massage.png" },
      { id: 2, name: "Back Massage", price: "10 AED", description: "Therapeutic back massage", image: "https://www.rapidhairsalon.ae/img/Back-Massage.png" }
    ]
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al Mansouri",
    role: "Business Executive",
    service: "Hair Cut & Styling",
    text: "The precision haircut I received was exceptional. They understand professional styling perfectly. My hair looks sharp and well-maintained for weeks. Highly recommend for business professionals.",
    rating: 5
  },
  {
    id: 2,
    name: "Marcus Thompson",
    role: "Entrepreneur",
    service: "Beard Grooming",
    text: "Best beard trim in Dubai! They shaped my beard perfectly and gave me grooming tips. The hot towel treatment was incredibly relaxing. Will definitely come back.",
    rating: 4.5
  },
  {
    id: 3,
    name: "Khalid Rahman",
    role: "Marketing Director",
    service: "Premium Facial",
    text: "The facial treatment was outstanding. My skin feels refreshed and rejuvenated. Perfect for combating Dubai's harsh climate. The staff is professional and knowledgeable.",
    rating: 5
  },
  {
    id: 4,
    name: "Youssef Abdullah",
    role: "Financial Consultant",
    service: "Hair Color Treatment",
    text: "Natural-looking gray coverage that exceeded my expectations. The color looks authentic and blends perfectly. Very satisfied with the results and the service quality.",
    rating: 4.5
  },
  {
    id: 5,
    name: "Rajesh Kumar",
    role: "IT Manager",
    service: "Head Massage",
    text: "The head massage was incredibly relaxing after a stressful week. Helped relieve tension and I left feeling completely refreshed. Great value for money.",
    rating: 5
  },
  {
    id: 6,
    name: "Omar Hassan",
    role: "Real Estate Agent",
    service: "Complete Grooming Package",
    text: "Got the full package - haircut, beard trim, and facial. Every service was top-notch. The team is skilled and the atmosphere is premium. Worth every dirham.",
    rating: 5
  },
  {
    id: 7,
    name: "David Miller",
    role: "Sales Manager",
    service: "Hair Straightening",
    text: "Hair straightening service was excellent. Results lasted for weeks and my hair is much more manageable now. The stylist was patient and professional throughout.",
    rating: 4.5
  },
  {
    id: 8,
    name: "Faisal Al Zaabi",
    role: "Architect",
    service: "Skin Polish & Face Care",
    text: "The skin polish treatment made my face glow. Noticed immediate results and compliments from colleagues. Perfect grooming solution for special occasions.",
    rating: 5
  }
];

export const whyChooseUs = [
  {
    icon: "⭐",
    title: "Premium Products",
    description: "We use only the finest international grooming products suited for UAE's climate"
  },
  {
    icon: "👨‍🎓",
    title: "Expert Team",
    description: "Internationally trained professionals with years of experience"
  },
  {
    icon: "💼",
    title: "Business-Friendly",
    description: "Quick service for busy professionals without compromising quality"
  },
  {
    icon: "🏆",
    title: "Proven Results",
    description: "Thousands of satisfied clients across Dubai and UAE"
  },
  {
    icon: "💯",
    title: "Satisfaction Guarantee",
    description: "Your confidence is our success - we don't stop until you're delighted"
  },
  {
    icon: "🕐",
    title: "Flexible Hours",
    description: "Open 7 days with extended hours to fit your schedule"
  }
];

// Service Detail Pages Data
export const serviceDetails = {
  hairCare: {
    id: 'hair-care',
    slug: 'hair-care',
    heroImage: "https://images.unsplash.com/photo-1718364673840-4bf5de5240b5?w=1920&q=80",
    title: "Professional Hair Care Services",
    subtitle: "PROFESSIONAL CUTS AND TREATMENTS FOR EVERY STYLE",
    about: {
      title: "Professional Hair Care Services",
      content: "At LookWell Gents Salon, we specialize in delivering premium hair care services tailored to Dubai's modern gentleman. Our expert stylists combine traditional barbering techniques with contemporary trends to create looks that enhance your professional image. Whether you need a sharp business cut, a trendy modern style, or specialized hair treatments, we provide personalized consultations to understand your lifestyle and preferences. Using only premium products suited for the UAE climate, we ensure your hair remains healthy, styled, and manageable in Dubai's unique environment.",
      image: "https://images.unsplash.com/photo-1761931403671-d020a14928d9?w=1200&q=85"
    },
    benefits: {
      title: "Why Choose Our Hair Care Services",
      content: "Experience professional expertise that delivers immediate and lasting results. Our specialized treatments are designed for Dubai's climate, ensuring your hair stays healthy, styled, and professional-looking between visits.",
      image: "https://images.unsplash.com/photo-1768363446104-b8a0c1716600?w=1200&q=85",
      list: [
        "Expert precision cutting for professional appearance",
        "Premium products suited for Dubai's climate",
        "Personalized styling consultations",
        "Long-lasting results and hair health improvement"
      ]
    },
    pricingIntro: "Our hair care services are competitively priced to offer exceptional value. From quick trims to complete transformations, we provide transparent pricing with no hidden costs. All services include consultation, premium products, and styling guidance.",
    cta: {
      title: "Ready for Your Best Look?",
      subtitle: "Book your hair care appointment today and experience the LookWell difference",
      content: "Join thousands of satisfied Dubai professionals who trust us with their grooming needs. Whether you're preparing for an important meeting, special event, or simply maintaining your signature style, our expert team is ready to deliver exceptional results.",
      backgroundImage: "https://images.unsplash.com/photo-1706629503603-e47c37722776?w=1920&q=80"
    },
    testimonials: [
      {
        id: 1,
        name: "Khalid Rahman",
        role: "Senior Manager, Tech Company",
        text: "I've been coming here for 2 years now. The consistency in quality is remarkable. My haircut always looks sharp and professional, exactly what I need for client meetings.",
        rating: 5
      },
      {
        id: 2,
        name: "James Peterson",
        role: "Investment Banker",
        text: "Finally found a salon that understands executive styling. Quick, professional, and the results speak for themselves. Worth every dirham.",
        rating: 5
      },
      {
        id: 3,
        name: "Ali Hassan",
        role: "Entrepreneur",
        text: "The stylists here are true professionals. They listen to what you want and deliver beyond expectations. Plus, the hair treatment products they use are top-notch.",
        rating: 4.5
      },
      {
        id: 4,
        name: "Michael Chen",
        role: "Marketing Director",
        text: "Best haircut experience in Dubai. The attention to detail is incredible, and they really know how to work with different hair types. Highly recommended!",
        rating: 5
      },
      {
        id: 5,
        name: "Omar Al Sayed",
        role: "Real Estate Developer",
        text: "Professional service from start to finish. The scalp massage during washing is so relaxing, and my hair feels healthier than ever. Great value for money.",
        rating: 4.5
      },
      {
        id: 6,
        name: "David Wilson",
        role: "Consultant",
        text: "I travel a lot for work and this is the only salon I trust in Dubai. Consistent quality, friendly staff, and they remember my preferences every time.",
        rating: 5
      }
    ]
  },
  faceCare: {
    id: 'face-care',
    slug: 'face-care',
    heroImage: "https://images.unsplash.com/photo-1722351153083-e32ff83a0c8a?w=1920&q=80",
    title: "Advanced Facial Care for Men",
    subtitle: "SPECIALIZED TREATMENTS FOR HEALTHY, GLOWING SKIN",
    about: {
      title: "Advanced Facial Care for Men",
      content: "Dubai's climate can be harsh on your skin. Our specialized facial treatments are designed specifically for men's skin care needs in the UAE environment. From deep cleansing facials that remove impurities to anti-aging treatments that maintain youthful appearance, we offer comprehensive solutions for every skin concern. Our expert aestheticians use premium, clinically-tested products suitable for all skin types. Each treatment begins with a thorough skin analysis to customize the service to your specific needs, ensuring optimal results and long-term skin health.",
      image: "https://images.unsplash.com/photo-1613223026022-afda5c1c95b8?w=800&q=80"
    },
    benefits: {
      title: "Transform Your Skin Health",
      content: "Our specialized facial treatments combat Dubai's climate effects, delivering visible results for healthier, younger-looking skin. From deep cleansing to anti-aging, we provide customized solutions for every skin type.",
      image: "https://images.unsplash.com/photo-1594051843839-c96c81ae011a?w=800&q=80",
      list: [
        "Deep cleansing removes impurities and toxins",
        "Anti-aging treatments reduce fine lines and wrinkles",
        "Climate-specific solutions for Dubai environment",
        "Professional-grade products for all skin types"
      ]
    },
    pricingIntro: "Invest in your skin with our professionally priced facial treatments. We offer individual services and package deals for regular maintenance. All treatments include skin analysis, premium products, and aftercare recommendations.",
    cta: {
      title: "Rejuvenate Your Skin Today",
      subtitle: "Experience professional facial care designed for Dubai's modern gentleman",
      content: "Don't let Dubai's climate take a toll on your skin. Our expert facial treatments provide the care and attention your skin deserves. Whether you're dealing with specific skin concerns or maintaining your healthy complexion, we have the perfect solution for you.",
      backgroundImage: "https://images.unsplash.com/photo-1640870071070-5cc384c49885?w=1920&q=80"
    },
    testimonials: [
      {
        id: 1,
        name: "Mohammed Rashid",
        role: "Corporate Executive",
        text: "The facial treatments here are exceptional. My skin has never looked better. The deep cleansing facial is perfect for Dubai's dusty environment.",
        rating: 5
      },
      {
        id: 2,
        name: "Robert Anderson",
        role: "Hotel Manager",
        text: "I was skeptical about facials for men, but this changed my mind completely. Professional service, visible results, and my skin feels amazing.",
        rating: 4.5
      },
      {
        id: 3,
        name: "Tariq Abdullah",
        role: "Architect",
        text: "Been getting monthly facials here for 6 months now. The improvement in my skin health is remarkable. No more dryness or irritation.",
        rating: 5
      },
      {
        id: 4,
        name: "Steven Clarke",
        role: "Financial Advisor",
        text: "Outstanding facial care services. The staff is knowledgeable, products are high-quality, and the results are immediately visible. Highly professional!",
        rating: 5
      },
      {
        id: 5,
        name: "Hassan Mahmoud",
        role: "Business Owner",
        text: "The anti-aging facial is worth every dirham. I look refreshed and years younger. The personalized approach makes all the difference.",
        rating: 4.5
      },
      {
        id: 6,
        name: "Thomas Wright",
        role: "Sales Director",
        text: "Excellent facial treatments with long-lasting results. The skin analysis helped identify issues I didn't even know I had. Great experience!",
        rating: 5
      }
    ]
  },
  beardCare: {
    id: 'beard-care',
    slug: 'beard-care',
    heroImage: "https://images.unsplash.com/photo-1718364673885-efc964e1b2cd?w=1920&q=80",
    title: "Expert Beard Grooming & Styling",
    subtitle: "MASTER YOUR BEARD WITH PROFESSIONAL CARE",
    about: {
      title: "Expert Beard Grooming & Styling",
      content: "A well-groomed beard is a signature of style and sophistication. At LookWell, we've elevated beard care to an art form. Our beard specialists understand the nuances of facial hair grooming, from classic straight razor shaves to modern beard sculpting. Whether you're growing your first beard or maintaining an established style, we provide expert guidance and premium services. Using professional-grade tools and products, we shape, trim, and condition your beard to achieve the perfect look that complements your facial features and personal style. Experience the confidence that comes with a professionally groomed beard.",
      image: "https://images.unsplash.com/photo-1733995471058-3d6ff2013de3?w=800&q=80"
    },
    benefits: {
      title: "Master Your Beard Style",
      content: "Expert beard grooming that goes beyond trimming. We address common concerns like itchiness and dryness while delivering sharp, professional results that complement your facial features and style preferences.",
      image: "https://images.unsplash.com/photo-1664051830150-28a69a2072d1?w=800&q=80",
      list: [
        "Precision trimming and shaping by experts",
        "Eliminates itchiness and dryness",
        "Professional-grade conditioning treatments",
        "Custom styling to complement face shape"
      ]
    },
    pricingIntro: "Our beard grooming services offer exceptional value with transparent pricing. From quick touch-ups to complete beard transformations, we provide professional care at competitive rates. All services include consultation and product recommendations.",
    cta: {
      title: "Perfect Your Beard Game",
      subtitle: "Book your professional beard grooming session today",
      content: "Your beard deserves professional attention. Whether you're maintaining your current style or trying something new, our beard specialists are here to help. Experience the difference that expert grooming makes in your overall appearance and confidence.",
      backgroundImage: "https://images.unsplash.com/photo-1672257493461-704902362c1d?w=1920&q=80"
    },
    testimonials: [
      {
        id: 1,
        name: "Abdullah Al Mazrouei",
        role: "Entrepreneur",
        text: "They transformed my unruly beard into a work of art. The hot towel treatment and beard oil application are incredible. Best beard grooming in Dubai!",
        rating: 5
      },
      {
        id: 2,
        name: "Marcus Johnson",
        role: "Creative Director",
        text: "I've tried many places, but nobody shapes a beard like these guys. Attention to detail is outstanding. My beard has never looked this good.",
        rating: 5
      },
      {
        id: 3,
        name: "Saeed Ahmed",
        role: "Lawyer",
        text: "Professional beard grooming at its finest. They understand how to maintain a corporate yet stylish look. The beard conditioning treatment is a game-changer.",
        rating: 4.5
      },
      {
        id: 4,
        name: "Patrick O'Brien",
        role: "Restaurant Owner",
        text: "The beard grooming service is exceptional. They take their time to get every detail right. My beard feels soft and looks sharp all week.",
        rating: 5
      },
      {
        id: 5,
        name: "Faisal Khalid",
        role: "Engineer",
        text: "Finally found a place that knows how to properly trim and shape a beard. The results are consistent every time. Highly recommended!",
        rating: 4.5
      },
      {
        id: 6,
        name: "Daniel Martinez",
        role: "Fitness Trainer",
        text: "Excellent beard grooming service. The staff is skilled, products are premium, and the environment is professional. Worth every visit!",
        rating: 5
      }
    ]
  },
  relaxation: {
    id: 'relaxation',
    slug: 'relaxation',
    heroImage: "https://images.unsplash.com/photo-1650044252595-cacd425982ff?w=1920&q=80",
    title: "Therapeutic Relaxation Services",
    subtitle: "ESCAPE THE STRESS, EMBRACE RELAXATION",
    about: {
      title: "Therapeutic Relaxation Services",
      content: "In Dubai's fast-paced business environment, stress relief is not a luxury—it's a necessity. Our therapeutic relaxation services are designed specifically for busy professionals who need to unwind and recharge. Our expert therapists use proven techniques combining traditional massage therapy with modern wellness practices. From targeted head massages that relieve tension headaches to comprehensive back treatments that ease muscle stress, we provide a tranquil escape from daily pressures. Each session is customized to address your specific stress points, promoting both physical relaxation and mental clarity.",
      image: "https://images.unsplash.com/photo-1583687780174-434f85f826b4?w=800&q=80"
    },
    benefits: {
      title: "Restore Your Energy & Focus",
      content: "Therapeutic treatments that reduce stress, improve circulation, and promote better sleep. Perfect for Dubai's busy professionals seeking mental and physical recovery in a high-pressure environment.",
      image: "https://images.unsplash.com/photo-1715408050790-17ffc3c74e46?w=800&q=80",
      list: [
        "Reduces stress and anxiety effectively",
        "Relieves muscle tension and headaches",
        "Improves blood circulation and energy levels",
        "Promotes better sleep quality"
      ]
    },
    pricingIntro: "Our relaxation services are affordably priced to make wellness accessible. Choose from quick stress-relief sessions or extended therapeutic treatments. All services use premium aromatic oils and include a calming environment.",
    cta: {
      title: "Escape the Stress, Embrace Relaxation",
      subtitle: "Book your therapeutic relaxation session now",
      content: "Your well-being matters. Take a break from the hustle and treat yourself to professional relaxation therapy. Whether you need quick stress relief during lunch break or a comprehensive wellness session, we're here to help you recharge and refocus.",
      backgroundImage: "https://images.unsplash.com/photo-1632482151560-ef0645f32999?w=1920&q=80"
    },
    testimonials: [
      {
        id: 1,
        name: "Rashid Al Thani",
        role: "Investment Manager",
        text: "The head massage is incredible for stress relief. After a long week of meetings, this is exactly what I need. Leave feeling completely refreshed.",
        rating: 5
      },
      {
        id: 2,
        name: "Christopher Lee",
        role: "IT Director",
        text: "Best therapeutic massage in Dubai. The therapists know exactly where the tension points are. My back pain is gone after just three sessions.",
        rating: 5
      },
      {
        id: 3,
        name: "Yousef Ibrahim",
        role: "Construction Manager",
        text: "The aromatherapy massage is pure bliss. Helps me unwind after stressful days on site. The calming environment adds to the whole experience.",
        rating: 4.5
      },
      {
        id: 4,
        name: "Andrew Thompson",
        role: "Marketing Executive",
        text: "I come here monthly for the back massage. It's therapeutic, professional, and incredibly relaxing. Helps me manage work stress effectively.",
        rating: 5
      },
      {
        id: 5,
        name: "Hamza Youssef",
        role: "Airline Pilot",
        text: "After long flights, the massage treatments here are a lifesaver. Professional service, skilled therapists, and great value for money.",
        rating: 4.5
      },
      {
        id: 6,
        name: "Richard Foster",
        role: "Finance Manager",
        text: "Outstanding relaxation services. The head and shoulder massage combo is perfect for relieving stress. Always leave feeling recharged and ready to go.",
        rating: 5
      }
    ]
  }
};
